import { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

// COMPONENTS
import WarehouseView from './WarehouseView';
import ProductManagerView from './ProductManagerView';
// API
import { getSamplingPlanView, getCategories } from '../../api/productSamplingWorkflowApi';
// CONTEXT
import usePlanDetailsContext from './context/usePlanDetailsContext';
import useStore from '../../states/store';

export default function SamplePlan() {
  const auth = useStore((state) => state.auth);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('plan_id');
  const type = searchParams.get('type');
  const [show, setShow] = useState(false);
  const [plan, setPlan] = useState({});
  const [loading, setLoading] = useState(true);
  const [planNotFound, setPlanNotFound] = useState(false);
  const [categories, setCategories] = useState([]);

  const loadCategoryDropdown = async () => {
    const response = await getCategories();
    const { code, data } = response.data;

    if (code === '200') {
      setCategories(data);
    }
  };

  useEffect(() => {
    if (auth) loadCategoryDropdown();
  }, []);

  useEffect(() => {
    const loadSamplingPlan = async () => {
      try {
        setLoading(true);
        setPlanNotFound(false);

        const response = await getSamplingPlanView({ id: token });
        const { code, data } = response.data;

        setShow(true);
        if (code === '200' && data) {
          setPlan(data);
          return;
        }

        setPlanNotFound(true);
      } catch (error) {
        setPlanNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    loadSamplingPlan();
  }, [token]);

  const contextValue = useMemo(
    () => ({ auth, plan, token, type, loading, planNotFound, categories }),
    [plan, token, type, loading, planNotFound, categories],
  );

  return (
    <usePlanDetailsContext.Provider value={contextValue}>
      {auth && type === 'pm' ? <ProductManagerView /> : show && <WarehouseView />}
    </usePlanDetailsContext.Provider>
  );
}
